export const colors = {
  space: "#1d1e2f",
  "international-orange": {
    "50": "#fff5ed",
    "100": "#ffe7d4",
    "200": "#ffcba8",
    "300": "#ffa770",
    "400": "#ff7637",
    "500": "#ff5818", // primary
    "600": "#f03706",
    "700": "#c72607",
    "800": "#9e1f0e",
    "900": "#7f1d0f",
    "950": "#450b05",
  },
  "purple-heart": {
    "50": "#eef1ff",
    "100": "#dfe4ff",
    "200": "#c6ccff",
    "300": "#a3aafe",
    "400": "#7e7ffb",
    "500": "#695ff5",
    "600": "#4f36e8", // secondary
    "700": "#4d34ce",
    "800": "#3e2da6",
    "900": "#362c83",
    "950": "#211a4c",
  },
  "spring-green": {
    "50": "#edfff7",
    "100": "#d5ffef",
    "200": "#aeffe0",
    "300": "#70ffc9",
    "400": "#2bfdac",
    "500": "#00fa9a", // mediumspringgreen
    "600": "#00c072",
    "700": "#00965c",
    "800": "#06754c",
    "900": "#076040",
    "950": "#003723",
  },
  dandelion: {
    "50": "#fffbeb",
    "100": "#fef2c7",
    "200": "#fde48a",
    "300": "#fcd256",
    "400": "#fbbb24",
    "500": "#f59a0b",
    "600": "#d97306",
    "700": "#b45009",
    "800": "#923e0e",
    "900": "#78330f",
    "950": "#451903",
  },
};

export const knoword = {
  "color-scheme": "light",
  primary: colors["international-orange"][500],
  "primary-content": colors["international-orange"][50],
  secondary: colors["purple-heart"][600],
  "secondary-content": colors["purple-heart"][50],
  accent: colors["spring-green"][500],
  "accent-content": colors["spring-green"][950],
  warning: colors.dandelion[300],
  "warning-content": colors.dandelion[900],
  neutral: "#1f2937", // gray-800
  "neutral-content": "#e5e7eb", // gray-200
  error: "#dc2626", // red-600
  "error-content": "#fef2f2", // red-50
  success: "#22c55e", // green-500
  "success-content": "#f0fff4", // green-50
  info: "#60a5fa", // blue-400
  "info-content": "#172554", // blue-950
  "base-100": "#fff", // white
  "base-200": "#f3f4f6", // gray-100
  "base-300": "#e5e7eb", // gray-200
  "base-content": "#111827", // gray-900
  "--animation-btn": "0",
};

export const dark = {
  ...knoword,
  "color-scheme": "dark",
  primary: colors["international-orange"][300],
  "primary-content": colors["international-orange"][900],
  secondary: colors["purple-heart"][300],
  "secondary-content": colors["purple-heart"][900],
  neutral: "#d1d5db", // gray-300
  "neutral-content": "#1f2937", // gray-800
  error: "#f87171", // red-400
  "error-content": "#450a0a", // red-950
  success: "#4ade80", // green-400
  "success-content": "#052e16", // green-950
  info: "#93c5fd", // blue-300
  "info-content": "#1e3a8a", // blue-900
  "base-100": "#111827", // gray-900
  "base-200": "#1f2937", // gray-800
  "base-300": "#374151", // gray-700
  "base-content": "#f9fafb", // gray-50
};
